import { CityGuide } from "@gigsync/protocol";
import { log } from "../log.js";
import { Collection } from "../ports.js";
/** This owner's move under way: the newest one they started on this phone, or undefined. */
export async function currentJourney(storage, owner) {
    const mine = (await storage.list(Collection.journeys)).filter((j) => j.owner === owner);
    return mine.sort((a, b) => b.started_at.localeCompare(a.started_at))[0];
}
export function saveJourney(storage, journey) {
    return storage.put(Collection.journeys, journey.id, journey);
}
/** The owner removes a move: started by mistake, or done with. */
export function removeJourney(storage, journey) {
    return storage.delete(Collection.journeys, journey.id);
}
/** The copy on this phone, if it still fits the schema: one saved by an older app may not. */
async function keptGuide(storage, city) {
    const kept = await storage.get(Collection.guides, city);
    const guide = CityGuide.safeParse(kept?.guide);
    return kept && guide.success ? { guide: guide.data, at: kept.at } : undefined;
}
/** The city's guide as kept on this phone, without asking the API: for screens that only read it (mentors' helplines). */
export async function savedGuide(storage, city) {
    return (await keptGuide(storage, city))?.guide;
}
/** How old a kept guide may be before the phone asks the API for a newer one: a draft changes, but not hourly. */
export const GUIDE_FRESH_MS = 24 * 60 * 60 * 1000;
/**
 * The city's guide: the phone's copy when it is fresh, else a new download (kept for next time), else the phone's
 * older copy when the API cannot be reached; undefined only when it was never downloaded and cannot be now.
 */
export async function loadGuide(storage, fetchGuide, city, now) {
    const kept = await keptGuide(storage, city);
    if (kept && now.getTime() - new Date(kept.at).getTime() < GUIDE_FRESH_MS)
        return { ...kept, offline: false };
    try {
        const guide = await fetchGuide(city);
        const saved = { guide, at: now.toISOString() };
        await storage.put(Collection.guides, city, saved);
        return { ...saved, offline: false };
    }
    catch (err) {
        log.warn("city guide not downloaded", { city, error: err instanceof Error ? err.message : String(err) });
        return kept ? { ...kept, offline: true } : undefined;
    }
}
//# sourceMappingURL=store.js.map